import React, { useMemo } from 'react';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import MagicForm from '../../../../Components/Form/MagicForm';
import { Workplace } from '../../../../graphql/graphql';
import { updateWorkplaceData } from '../../../Manager/Services/workplaceUpdate.service';
import useLoading from '../../../Base/Hooks/useLoading';
import useApiClient from '../../../Base/Hooks/useApiClient';

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		title: 'component.ORSMWorkplaceOrderingRestrictionSettings.title',
		settings: {
			labelStyle: {
				color: '#1d65d8',
				fontWeight: 500,
				fontSize: '14px',
				marginBottom: '10px',
			},
		},
	},
	{
		type: MagicField.RADIOLIST,
		key: 'onlineOrderTarget',
		children: [
			{
				key: 'WORKPLACE_MEMBER',
				value: 'WORKPLACE_MEMBER',
				title:
					'component.ORSMWorkplaceOrderingRestrictionSettings.workplaceMember',
			},
			{
				key: 'WORKPLACE',
				value: 'WORKPLACE',
				title: 'component.ORSMWorkplaceOrderingRestrictionSettings.workplace',
			},
		],
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'onlineOrderTarget',
					rule: 'equal',
					value: 'WORKPLACE_MEMBER',
				},
			],
		},
		subType: 'view',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'memberSearchableOutside',
				title:
					'component.ORSMWorkplaceOrderingRestrictionSettings.memberSearchableOutside',
			},
		],
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'onlineOrderTarget',
					rule: 'equal',
					value: 'WORKPLACE',
				},
			],
		},
		subType: 'view',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'workplaceSearchableOutside',
				title:
					'component.ORSMWorkplaceOrderingRestrictionSettings.workplaceSearchableOutside',
			},
		],
	},
];

interface FormValues {
	onlineOrderTarget: string;
	memberSearchableOutside: boolean;
	workplaceSearchableOutside: boolean;
}

interface Props {
	workplace: Workplace;
	onUpdate: () => Promise<void>;
}

const ORSMWorkplaceOrderingRestrictionSettings: React.FC<Props> = ({
	workplace,
	onUpdate,
}) => {
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { displayError } = useApiClient();

	const defaultData = useMemo(() => {
		return {
			onlineOrderTarget: workplace.onlineOrderTarget,
			memberSearchableOutside: workplace.memberSearchableOutside,
			workplaceSearchableOutside: workplace.workplaceSearchableOutside,
		};
	}, [workplace]);

	const handleSubmit = async (values: FormValues) => {
		setIsLoading(true);
		try {
			const response = await updateWorkplaceData(workplace.id, values);
			if (response.status === 200) {
				await onUpdate();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<MagicForm
			formScheme={FORM_SCHEME}
			onSubmit={handleSubmit}
			defaultValues={defaultData}
		/>
	);
};

export default ORSMWorkplaceOrderingRestrictionSettings;
